var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobileSection"},[_c('Headline'),_c('Anywhere'),_c('Teachers'),_c('Administrators'),_c('Students'),_c('GetApp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }